module.exports = __webpack_public_path__ + "img/loading_new_year_2020_2_2cecb87e0.jpg";